// extracted by mini-css-extract-plugin
export default {"form":"PartnerForm_form__+NIul","field":"PartnerForm_field__Us9z-","checkbox":"PartnerForm_checkbox__AKo2B","error":"PartnerForm_error__hE7Fk","link":"PartnerForm_link__UCW7-"};